<style scoped>
@import url("../../assets/sanger.css");
@import url("../../assets/service.css");
</style>
<style lang="scss" scoped>
.container10{
  margin-top: 80px;
}
.cons{
  display: none;
}

.container10 h1{
  font-size: 70px;
  color: #014492;
}
.container10 h2{
  font-size: 40px;
  color: #014492;
}
.container10 .a{
  width: 1000px;
  height: 6px;
  margin-top: 30px;
  margin-bottom: 40px;
  background: #ccc;
  position: relative;
}
.container10 .a span{
  width: 50px;
  height: 6px;
  position: absolute;
  left: 0;
  top: 0;
  background: #014492;
}
</style>
<template>
  <div class="wrap wrap-tec">
<!--    <div class="banner">-->
<!--      <img src="@/assets/images/banner_16.png" class="img-fluid">-->
<!--      <div class="info">-->
<!--        <div class="container">-->
<!--          <h1>线粒体/叶绿体精细图测序</h1>-->
<!--          <h2 class="mt10">Mitochondrial / chloroplast fine map sequencing</h2>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
    <div class="container container10">
      <h1>线粒体/叶绿体精细图测序</h1>
      <h2 class="mt10">Mitochondrial / Chloroplast Fine Map Sequencing</h2>
      <div class="a"><span></span></div>
    </div>
    <div class="breads container" style="overflow:auto;line-height: 48px;padding-left: 10px;">
      <bread></bread>
    </div>
    <section class="container">
      <p class="desc">叶绿体是绿色植物的重要细胞器，具有独立基因组（cpDNA），cpDNA在揭示物种起源、生物进化、不同物种间亲缘关系等方面有十分重要的作用。线粒体DNA（mtDNA）因其独特的母系遗传模式和较高的突变频率，已被广泛应用于生物进化、群体结构、疾病诊断等方面的研究。二代测序可以在相对短的时间内获得大量数据，用于cpDNA/mtDNA组装及分析，是研究叶绿体/线粒体基因组的重要技术。但鉴于cpDNA和mtDNA结构比较复杂，此种方式不一定可以得到基因组全部序列，建议有近缘参考的物种采用二代测序，无近缘参考的物种选择三代测序。植物线粒体因为结构更为复杂，一般不推荐采用二代测序的方式进行组装，推荐三代测序的方式。</p>
      <div class="c-title">技术参数</div>
      <table class="table">
        <tr>
          <th style="width:400px;">类型</th>
          <th>二代测序</th>
        </tr>
        <tr>
          <td>DNA类型</td>
          <td>Total DNA</td>
        </tr>
        <tr>
          <td>读长</td>
          <td>PE150</td>
        </tr>
        <tr>
          <td>仪器</td>
          <td>Hiseq/Novaseq</td>
        </tr>
        <!-- <tr>
          <td>数据量</td>
          <td>4 G</td>
        </tr> -->
        <tr>
          <td>优缺点</td>
          <td>准确率高，价格便宜；但由于技术限制，可能得不到全长叶绿体/线粒体序列</td>
        </tr>
        <tr>
          <td>项目周期</td>
          <td>30个自然日</td>
        </tr>
      </table>
      <div class="c-title">技术路线</div>
      <div class="tc con"><img src="@/assets/images/mitochondrial_1.png"> </div>
      <div class="tc cons" style="margin-top: 20px;"><img src="@/assets/images/mitochondrial_1.png"> </div>
    </section>
    <qk-consult type="Virus"/>
  </div>
</template>
<script>
import bread from "@/components/bread"
export default {
  inject: ['reload'],
  components: {
    bread,
  },
  data () {
    return {

    }
  },
  created() {
    this.reload()
  },
  methods: {

  }
}
</script>



// WEBPACK FOOTER //
// src/views/tec/mitochondrial.vue